import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'

const useUserInvitationApi = () => {
  const addToast = useToastContext()

  const [userInvitationState, setUserInvitationState] = useState({
    reponse: {},
    getResponse: {},
    count: 0,
    isLoading: false,
    error: null,
  })

  async function createUserInvitation(data, callback) {
    try {
      setUserInvitationState((currentuserInvitationState) => ({
        ...currentuserInvitationState,
        isLoading: true,
        error: null,
      }))
      let url = `/invitations`
      const response = await api.post(url, data)
      await getInvitations(userInvitationState?.params)
      if (callback) {
        await callback(response.data)
      }
      setUserInvitationState((currentuserInvitationState) => ({
        isLoading: false,
        error: null,
        ...currentuserInvitationState,
      }))
      addToast(notificationTypes.success, 'Invitacion creada con exito!')
    } catch (error) {
      setUserInvitationState({
        reponse: {},
        isLoading: false,
        error: error?.response?.data,
      })
      console.log('error', error.response)
      addToast(
        notificationTypes.error,
        error?.response?.data?.message || 'Lo sentimos, ah ocurrido un error.'
      )
    }
  }

  async function updateUserInvitation(id, data) {
    try {
      setUserInvitationState((currentuserInvitationState) => ({
        ...currentuserInvitationState,
        isLoading: true,
        error: null,
      }))
      let url = `/invitations/${id}`
      const response = await api.put(url, data)

      setUserInvitationState({
        getResponse: response.data,
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setUserInvitationState({
        reponse: {},
        isLoading: false,
        error: error?.response?.data,
      })
    }
  }

  async function deleteInvitation(id, params) {
    try {
      let url = `/invitations/${id}`
      await api.remove(url)
      addToast(notificationTypes.success, 'Autorizado borrado con exito!')
      await getInvitations(params)
    } catch (error) {
      addToast(notificationTypes.success, 'Error al borrar autorizado!')
      setUserInvitationState({
        reponse: {},
        isLoading: false,
        error: error?.response?.data,
      })
    }
  }

  async function getUserInvitation(id) {
    try {
      setUserInvitationState((currentuserInvitationState) => ({
        ...currentuserInvitationState,
        isLoading: true,
        error: null,
      }))

      let url = `/invitations/${id}?includeAccessInfo=true`
      const response = await api.get(url)
      setUserInvitationState((currentuserInvitationState) => ({
        ...currentuserInvitationState,
        getResponse: response.data,
        isLoading: false,
        error: null,
      }))
    } catch (error) {
      setUserInvitationState((currentuserInvitationState) => ({
        ...currentuserInvitationState,
        getReponse: {},
        isLoading: false,
        error: error?.response?.data,
      }))
    }
  }

  async function getInvitations(params) {
    try {
      setUserInvitationState((currentuserInvitationState) => ({
        ...currentuserInvitationState,
        isLoading: true,
        error: null,
        params,
      }))
      let url = `/invitations`

      const response = await api.get(url, {
        params,
        includeToken: true,
      })
      const responseSettings = await api.get('/settings')
      setUserInvitationState((currentuserInvitationState) => ({
        ...currentuserInvitationState,
        invitations: response.data,
        serviceTypes: responseSettings?.data?.serviceTypes,
        isLoading: false,
        error: null,
      }))
    } catch (error) {
      setUserInvitationState({
        getReponse: {},
        isLoading: false,
        error: error?.response?.data,
      })
    }
  }

  async function getSettings(shopping = false) {
    try {
      setUserInvitationState((currentuserInvitationState) => ({
        ...currentuserInvitationState,
        isLoading: true,
        error: null,
      }))
      let url = '/settings'
      if (shopping) {
        url += `?shopping=${shopping}`
      }
      const responseSettings = await api.get(url)
      setUserInvitationState((currentuserInvitationState) => ({
        ...currentuserInvitationState,
        serviceTypes: responseSettings?.data?.serviceTypes,
        isLoading: false,
        error: null,
      }))
    } catch (error) {
      setUserInvitationState({
        getReponse: {},
        isLoading: false,
        error: error?.response?.data,
      })
    }
  }

  const state = {
    userInvitationState,
  }

  const methods = {
    updateUserInvitation,
    getUserInvitation,
    getInvitations,
    deleteInvitation,
    createUserInvitation,
    getSettings,
  }

  return [state, methods]
}

export default useUserInvitationApi
